import { create } from 'zustand';

export interface ToastAction {
  label: string;
  onClick: () => void;
}

export interface ToastItem {
  id: number;
  message: string;
  type?: 'info' | 'warning' | 'error' | 'success';
  action?: ToastAction;
}

export interface ToastOptions {
  // 自动消失时长（毫秒）；传 0 或 Infinity 则常驻，需手动关闭（如版本更新提示）
  duration?: number;
  action?: ToastAction;
}

interface ToastState {
  toasts: ToastItem[];
  addToast: (message: string, type?: ToastItem['type'], options?: ToastOptions) => void;
  removeToast: (id: number) => void;
}

const DEFAULT_DURATION = 3000;

let nextId = 0;

export const useToastStore = create<ToastState>((set) => ({
  toasts: [],
  addToast: (message, type = 'info', options) => {
    const id = ++nextId;
    set((s) => ({ toasts: [...s.toasts, { id, message, type, action: options?.action }] }));
    // duration 为 0 / Infinity 时常驻，由调用方通过 action 或 removeToast 关闭
    const duration = options?.duration ?? DEFAULT_DURATION;
    if (Number.isFinite(duration) && duration > 0) {
      setTimeout(() => {
        set((s) => ({ toasts: s.toasts.filter((t) => t.id !== id) }));
      }, duration);
    }
  },
  removeToast: (id) => set((s) => ({ toasts: s.toasts.filter((t) => t.id !== id) })),
}));
